import {Injectable} from "@angular/core";
import {BaseService} from "@core/service/base.service";
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";
@Injectable({providedIn: 'root'})
export class ExcelService extends BaseService {


  private url = '';

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return this.url;
  }

  /**
   * 获取可导出字段
   * @param url
   * @returns {Observable<any|any>}
   */
  getExcelTitle(url):Observable<any[]> {
    const excelUrl = `${url}/excel-title`;
    return this.http.get<any>(excelUrl).pipe(
      tap(_ => this.log(`getExcelTitle`)),
      catchError(this.handleError<any>(`getExcelTitle`))
    );
  }

  /**
   * 导出excel
   * @param url
   * @returns {Observable<any|any>}
   */
  outPutExcel(url, titles, params, processCode):Observable<any> {
    const excelUrl = `${url}/excel-export`;
    return this.http.put(excelUrl, titles, {
      responseType: 'arraybuffer',
      params: params,
      headers: {
        'Process': processCode,
        'Content-Type': 'application/json'
      }
    });
  }
}

